// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2548":"74575428","3198":"8572232f","3922":"64c4434f","4070":"231568f1","4805":"64c4434f","5980":"8572232f","7593":"8a37d5f4"}[chunkId] + ".chunk.css";
};